<template>
  <div
    class="w-full pt-[78px] desktop:pt-[94px] tablet-h:pt-10 tablet-v:pt-[111px] text-[26px] leading-[36px] text-gray-800 font-secondary font-[370] text-center flex flex-col items-center px-6"
  >
    <div class="w-full max-w-[450px] flex flex-col flex-grow">
      <div class="max-w-[350px] tablet-v:w-full mx-auto mb-5">
        Did you know that there's over
        <span class="text-green-700 font-semibold">1.1 billion</span> original
        works created each year and
        <span class="text-red-500 font-semibold">99.6%</span> of them are
        <span class="text-red-500 font-semibold slant">not</span>
        protected?
      </div>

      <div class="mt-auto w-full">
        <TestimonialCard
          :quote="testimonial.quote"
          :author="testimonial.author"
          class="mb-[30px]"
        />

        <UiButton class="w-full" primary large @click="handleClick">
          Next
        </UiButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { UiButton } from '@dacr/ui'
import TestimonialCard from '@/shared/components/TestimonialCard.vue'
import { useCompleteStepMutation } from '@/shared/graphql/legacy/generated'
import BenAvatar from '@/assets/images/Ben-Avatar.jpg'
import { useOnboardingStore } from '@/features/onboarding/store'

const testimonial = {
  quote:
    'Dacr is a tremendous legal tool for anyone looking to stop IP theft and can be very useful on both the state and federal levels, as well as in foreign territories.',
  author: {
    avatarUrl: BenAvatar,
    name: 'Benjamin Dach',
    title: 'Intellectual Property Attorney',
  },
}

const { mutate: completeStep } = useCompleteStepMutation()

const onboardingStore = useOnboardingStore()

const handleClick = () => {
  completeStep({
    step: 6,
  })

  onboardingStore.goToNextStep()
}
</script>
